(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-bundle"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('td-benefits-modal')) {
    class TdBenefitsModal extends HTMLElement {
      constructor() {
        super();

        this.handleOverlayClick = this.handleOverlayClick.bind(this);
        this.handleCloseClick = this.handleCloseClick.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
      }

      connectedCallback() {
        this.overlay = this.querySelector('.td-benefits-modal__overlay');
        this.content = this.querySelector('.td-benefits-modal__content');
        this.closeButton = this.querySelector('.td-benefits-modal__close');

        if (this.overlay) {
          this.overlay.addEventListener('click', this.handleOverlayClick);
        }

        if (this.closeButton) {
          this.closeButton.addEventListener('click', this.handleCloseClick);
        }

        this.addEventListener('keydown', this.handleKeydown);
      }

      disconnectedCallback() {
        if (this.overlay) {
          this.overlay.removeEventListener('click', this.handleOverlayClick);
        }

        if (this.closeButton) {
          this.closeButton.removeEventListener('click', this.handleCloseClick);
        }

        this.removeEventListener('keydown', this.handleKeydown);
      }

      getFocusableElements() {
        const selectors = [
          'a[href]',
          'area[href]',
          'button:not([disabled])',
          'input:not([disabled]):not([type="hidden"])',
          'select:not([disabled])',
          'textarea:not([disabled])',
          'iframe',
          'object',
          'embed',
          '[contenteditable]',
          '[tabindex]:not([tabindex="-1"])',
        ].join(',');

        return Array.from(this.querySelectorAll(selectors)).filter((element) => {
          return !element.hasAttribute('hidden') && element.getAttribute('aria-hidden') !== 'true';
        });
      }

      open(trigger) {
        this.trigger = trigger || document.activeElement;
        this.removeAttribute('hidden');

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.classList.add('td-benefits-modal--open');
            const scrollY = window.scrollY || window.pageYOffset || 0;
            document.documentElement.classList.add('td-benefits-modal-open');
            document.body.classList.add('td-benefits-modal-open');
            document.body.style.top = `-${scrollY}px`;
            document.body.dataset.tdBenefitsModalScrollY = String(scrollY);

            const focusableElements = this.getFocusableElements();
            const initialFocus = focusableElements[0] || this.content || this;

            if (initialFocus) {
              initialFocus.focus();
            }
          });
        });
      }

      close() {
        this.classList.remove('td-benefits-modal--open');
        const scrollY = parseInt(document.body.dataset.tdBenefitsModalScrollY || '0', 10);

        document.documentElement.classList.remove('td-benefits-modal-open');
        document.body.classList.remove('td-benefits-modal-open');
        document.body.style.top = '';
        delete document.body.dataset.tdBenefitsModalScrollY;

        const restoreFocus = () => {
          this.setAttribute('hidden', '');
          window.scrollTo(0, scrollY);

          if (this.trigger && typeof this.trigger.focus === 'function') {
            this.trigger.focus();
          }
        };

        if (this.content) {
          this.content.addEventListener('transitionend', restoreFocus, { once: true });
        } else {
          restoreFocus();
        }
      }

      handleOverlayClick() {
        this.close();
      }

      handleCloseClick() {
        this.close();
      }

      handleKeydown(event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          this.close();
          return;
        }

        if (event.key !== 'Tab') return;

        const focusableElements = this.getFocusableElements();

        if (!focusableElements.length) {
          event.preventDefault();
          return;
        }

        const firstFocusable = focusableElements[0];
        const lastFocusable = focusableElements[focusableElements.length - 1];

        if (event.shiftKey && document.activeElement === firstFocusable) {
          event.preventDefault();
          lastFocusable.focus();
          return;
        }

        if (!event.shiftKey && document.activeElement === lastFocusable) {
          event.preventDefault();
          firstFocusable.focus();
        }
      }
    }

    customElements.define('td-benefits-modal', TdBenefitsModal);
  }

  if (!window.tdBenefitsModalTriggerHandlerBound) {
    window.tdBenefitsModalTriggerHandlerBound = true;

    document.addEventListener('click', function (event) {
      const path = event.composedPath();
      const trigger = path.find(function (element) {
        return element instanceof Element && element.dataset && element.dataset.benefitsModalId;
      });

      if (!trigger) return;

      const modal = document.getElementById(trigger.dataset.benefitsModalId);
      if (!modal || typeof modal.open !== 'function') return;

      event.preventDefault();
      modal.open(trigger);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('td-benefits-modal')) {
    class TdBenefitsModal extends HTMLElement {
      constructor() {
        super();

        this.handleOverlayClick = this.handleOverlayClick.bind(this);
        this.handleCloseClick = this.handleCloseClick.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
      }

      connectedCallback() {
        this.overlay = this.querySelector('.td-benefits-modal__overlay');
        this.content = this.querySelector('.td-benefits-modal__content');
        this.closeButton = this.querySelector('.td-benefits-modal__close');

        if (this.overlay) {
          this.overlay.addEventListener('click', this.handleOverlayClick);
        }

        if (this.closeButton) {
          this.closeButton.addEventListener('click', this.handleCloseClick);
        }

        this.addEventListener('keydown', this.handleKeydown);
      }

      disconnectedCallback() {
        if (this.overlay) {
          this.overlay.removeEventListener('click', this.handleOverlayClick);
        }

        if (this.closeButton) {
          this.closeButton.removeEventListener('click', this.handleCloseClick);
        }

        this.removeEventListener('keydown', this.handleKeydown);
      }

      getFocusableElements() {
        const selectors = [
          'a[href]',
          'area[href]',
          'button:not([disabled])',
          'input:not([disabled]):not([type="hidden"])',
          'select:not([disabled])',
          'textarea:not([disabled])',
          'iframe',
          'object',
          'embed',
          '[contenteditable]',
          '[tabindex]:not([tabindex="-1"])',
        ].join(',');

        return Array.from(this.querySelectorAll(selectors)).filter((element) => {
          return !element.hasAttribute('hidden') && element.getAttribute('aria-hidden') !== 'true';
        });
      }

      open(trigger) {
        this.trigger = trigger || document.activeElement;
        this.removeAttribute('hidden');

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.classList.add('td-benefits-modal--open');
            const scrollY = window.scrollY || window.pageYOffset || 0;
            document.documentElement.classList.add('td-benefits-modal-open');
            document.body.classList.add('td-benefits-modal-open');
            document.body.style.top = `-${scrollY}px`;
            document.body.dataset.tdBenefitsModalScrollY = String(scrollY);

            const focusableElements = this.getFocusableElements();
            const initialFocus = focusableElements[0] || this.content || this;

            if (initialFocus) {
              initialFocus.focus();
            }
          });
        });
      }

      close() {
        this.classList.remove('td-benefits-modal--open');
        const scrollY = parseInt(document.body.dataset.tdBenefitsModalScrollY || '0', 10);

        document.documentElement.classList.remove('td-benefits-modal-open');
        document.body.classList.remove('td-benefits-modal-open');
        document.body.style.top = '';
        delete document.body.dataset.tdBenefitsModalScrollY;

        const restoreFocus = () => {
          this.setAttribute('hidden', '');
          window.scrollTo(0, scrollY);

          if (this.trigger && typeof this.trigger.focus === 'function') {
            this.trigger.focus();
          }
        };

        if (this.content) {
          this.content.addEventListener('transitionend', restoreFocus, { once: true });
        } else {
          restoreFocus();
        }
      }

      handleOverlayClick() {
        this.close();
      }

      handleCloseClick() {
        this.close();
      }

      handleKeydown(event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          this.close();
          return;
        }

        if (event.key !== 'Tab') return;

        const focusableElements = this.getFocusableElements();

        if (!focusableElements.length) {
          event.preventDefault();
          return;
        }

        const firstFocusable = focusableElements[0];
        const lastFocusable = focusableElements[focusableElements.length - 1];

        if (event.shiftKey && document.activeElement === firstFocusable) {
          event.preventDefault();
          lastFocusable.focus();
          return;
        }

        if (!event.shiftKey && document.activeElement === lastFocusable) {
          event.preventDefault();
          firstFocusable.focus();
        }
      }
    }

    customElements.define('td-benefits-modal', TdBenefitsModal);
  }

  if (!window.tdBenefitsModalTriggerHandlerBound) {
    window.tdBenefitsModalTriggerHandlerBound = true;

    document.addEventListener('click', function (event) {
      const path = event.composedPath();
      const trigger = path.find(function (element) {
        return element instanceof Element && element.dataset && element.dataset.benefitsModalId;
      });

      if (!trigger) return;

      const modal = document.getElementById(trigger.dataset.benefitsModalId);
      if (!modal || typeof modal.open !== 'function') return;

      event.preventDefault();
      modal.open(trigger);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function() {
    // Global object to track timers across section re-renders
    window.tdAnnouncementTimers = window.tdAnnouncementTimers || {};

    // Get DOM elements with null checks
    var announcementBarEl = document.querySelector('[data-announcement-bar-id]');
    var timerDateEl = document.querySelector('[data-announcement-bar-timer-date]');

    // Only initialize if dependent elements present
    if (!announcementBarEl || !timerDateEl) {
      return;
    }

    var currentSectionId = announcementBarEl.getAttribute('data-announcement-bar-id');
    var timerDate = timerDateEl.getAttribute('data-announcement-bar-timer-date');

    // Exit early if required data attributes are missing
    if (!currentSectionId || !timerDate) {
      return;
    }

    // Clear existing timer for this section if it exists
    if (window.tdAnnouncementTimers[currentSectionId]) {
      clearInterval(window.tdAnnouncementTimers[currentSectionId]);
    }

    // Set the date we're counting down to
    var countDownDate = new Date(timerDate).getTime();

    // Exit if the date is invalid
    if (isNaN(countDownDate)) {
      return;
    }

    // Update the count down every 1 second
    var x = setInterval(function () {
      // Get today's date and time
      var now = new Date().getTime();

      // Find the distance between now and the count down date
      var distance = countDownDate - now;

      // Time calculations for hours, minutes and seconds
      var hours = Math.floor(distance / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // Format with leading zeros
      var hoursStr = hours < 10 ? '0' + hours : hours;
      var minutesStr = minutes < 10 ? '0' + minutes : minutes;
      var secondsStr = seconds < 10 ? '0' + seconds : seconds;

      var sectionSelector = '.section-' + currentSectionId;
      var hoursEls = document.querySelectorAll(sectionSelector + ' .timer-h');
      var minutesEls = document.querySelectorAll(sectionSelector + ' .timer-m');
      var secondsEls = document.querySelectorAll(sectionSelector + ' .timer-s');

      hoursEls.forEach(function (el) {
        el.innerHTML = hoursStr;
      });
      minutesEls.forEach(function (el) {
        el.innerHTML = minutesStr;
      });
      secondsEls.forEach(function (el) {
        el.innerHTML = secondsStr;
      });

      // If the count down is finished, clear the interval
      if (distance < 0) {
        clearInterval(x);
      }
    }, 1000);

    // Store the new timer ID
    window.tdAnnouncementTimers[currentSectionId] = x;
  })();

  } catch(e) { console.error(e); }
})();
})();
